import {
  Cpu,
  GraduationCap,
  LifeBuoy,
  TrendingUp,
  Handshake,
  Truck,
  FileEdit,
  Search,
  type LucideIcon,
} from "lucide-react";

export interface PartnerBenefit {
  icon: LucideIcon;
  title: string;
  text: string;
}

export const partnerBenefits: PartnerBenefit[] = [
  {
    icon: Cpu,
    title: "Tecnologia própria",
    text: "Produtos exclusivos com alto valor agregado.",
  },
  {
    icon: GraduationCap,
    title: "Treinamentos",
    text: "Capacitação completa e materiais de apoio comercial e técnico.",
  },
  {
    icon: LifeBuoy,
    title: "Suporte consultivo",
    text: "Acompanhamento em todas as etapas do processo.",
  },
  {
    icon: TrendingUp,
    title: "Mercados em expansão",
    text: "Atuação em segmentos como educação e esportes.",
  },
  {
    icon: Handshake,
    title: "Liberdade para revender",
    text: "Leve as soluções Alert AI aos seus clientes.",
  },
  {
    icon: Truck,
    title: "Liberdade para distribuir",
    text: "Distribua as soluções em sua região.",
  },
];

export const partnerModel = {
  commission: {
    base: "5%",
    max: "10%",
    title: "Comissionamento recorrente",
    text: "Revendas que indicam novos clientes recebem 5% sobre o valor do contrato, podendo chegar a 10% conforme o envolvimento na implantação e no pós-venda. A comissão é recorrente durante toda a vigência do contrato.",
  },
  direct: {
    title: "Contratação direta",
    text: "A revenda pode contratar diretamente com condições diferenciadas e aplicar sua própria margem sobre os valores, mantendo o controle da competitividade da oferta.",
  },
};

export interface PartnerProcessStep {
  icon: LucideIcon;
  title: string;
  text: string;
}

export const partnerProcess: PartnerProcessStep[] = [
  {
    icon: FileEdit,
    title: "Preencha o cadastro",
    text: "5 etapas rápidas sobre sua empresa, contatos e experiência de mercado.",
  },
  {
    icon: Search,
    title: "Nossa equipe analisa",
    text: "Avaliamos o perfil, a documentação e a área de cobertura informada.",
  },
  {
    icon: Handshake,
    title: "Vire parceiro Alert AI",
    text: "Você recebe o retorno com os próximos passos da homologação.",
  },
];

export const partnerRoutes = {
  reseller: "/alertAi-revendas",
  distributor: "/alertAI-distributor",
  hub: "/alertAI-partners",
};
